import PropTypes from 'prop-types';

export const FETCH_SHAPE = PropTypes.shape({
  pending: PropTypes.bool,
  fulfilled: PropTypes.bool,
  rejected: PropTypes.bool,
  value: PropTypes.any,
});

export const OPTIONS_ARRAY = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  })
);

export const REGISTRATION_PARAMETERS_SHAPE = PropTypes.shape({
  id: PropTypes.string,
  token: PropTypes.string.isRequired,
  payload: PropTypes.shape({
    user: PropTypes.shape({
      languageId: PropTypes.string.isRequired,
    }),
  }),
});

export const REGISTRATION_TEMPLATE_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  communityTag: PropTypes.string.isRequired,
});

export const COMMUNITY_TEMPLATE_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
});

export const COMMUNITY_MEMBERSHIP_REQUEST_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
});
